import React from 'react';
import {TextButton, TextButtonPriority} from 'wix-ui-tpa/cssVars';
import {useLocaleKeys} from '../../../locale-keys/LocaleKeys';
import {st, classes} from './Header.st.css';
import {useControllerProps} from '../Widget/ControllerContext';
import {CheckoutSlot} from '../CheckoutSlot';
import {SlotId} from '../../../domain/utils/slotId';
import {StoreNameAndLogo} from '../../../common/components/StoreNameAndLogo/StoreNameAndLogo';
import {useExperiments} from '@wix/yoshi-flow-editor';
import {SPECS} from '../../../common/constants';

export enum HeaderDataHooks {
  ContinueShoppingButton = 'HeaderDataHooks.ContinueShoppingButton',
}

export const Header = ({dataHook}: {dataHook: string}) => {
  const {isOneColumnView} = useControllerProps();
  const localKeys = useLocaleKeys();
  const {
    checkoutSettingsStore: {checkoutSettings, checkoutContent},
    navigationStore: {continueShoppingUrl, clickOnContinueShopping, isContinueShoppingEnabled},
  } = useControllerProps();
  const {experiments} = useExperiments();
  const continueShoppingText = checkoutContent?.continueShoppingLink ?? localKeys.checkout.continue_shopping();

  return (
    <header className={classes.header}>
      <div
        className={st(
          experiments.enabled(SPECS.FixCheckoutHeaderCSS)
            ? classes.innerHeader
            : /* istanbul ignore next */ classes.innerHeaderOld
        )}
        data-hook={dataHook}>
        <StoreNameAndLogo
          continueShoppingUrl={continueShoppingUrl}
          clickOnContinueShopping={clickOnContinueShopping}
          logoUrl={checkoutSettings.logoUrl}
          storeName={checkoutSettings.storeName}
          checkoutHeader={checkoutSettings.checkoutHeader}
          isOneColumnView={isOneColumnView}
        />
        {isContinueShoppingEnabled && (
          <TextButton
            as={'a'}
            className={
              experiments.enabled(SPECS.FixCheckoutHeaderCSS)
                ? classes.continueShoppingButton
                : /* istanbul ignore next */ classes.continueShoppingButtonOld
            }
            data-hook={HeaderDataHooks.ContinueShoppingButton}
            href={continueShoppingUrl}
            onClick={() => clickOnContinueShopping()}
            priority={TextButtonPriority.link}>
            {continueShoppingText}
          </TextButton>
        )}
      </div>
      <div className={classes.divider} />
      <CheckoutSlot
        className={isOneColumnView ? classes.headerCheckoutSlotMobile : classes.headerCheckoutSlot}
        slotId={SlotId.HeaderCheckoutSlot}
      />
    </header>
  );
};
